<template>
    <div class="dsum">
        <ul>
            <li v-if="selectedDiamond !== null">
                <span>{{ t("singleDiamondsConfigurator.priceLabel") }}</span>
                <span>{{ diamondPriceFormatted }}</span>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import usePrices from "@/composables/usePrices";
import useStore from "@/composables/useStore";
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import formatCurrency from "@/utils/formatCurrency";

export default defineComponent({
    name: "SingleDiamondSelectionSummary",
    setup() {
        const {
            computed: { selectedDiamond },
        } = useStore();
        const { t, n } = useI18n();

        const diamondPrice = computed(() =>
            selectedDiamond.value ? selectedDiamond.value.price / 100 : 0
        );
        const diamondPriceFormatted = computed(() =>
            formatCurrency(diamondPrice.value)
        );

        const diamondText = computed(() => {
            return `${selectedDiamond.value?.carat} ${t("components.ct")} ${t(
                `diamondProperties.shape.${selectedDiamond.value?.shape}`
            )} / ${t("components.color")}: ${
                selectedDiamond.value?.color
            } / ${t("components.clarity")}: ${selectedDiamond.value?.clarity}`;
        });

        const totalText = t("components.total");

        return {
            t,
            selectedDiamond,
            diamondText,
            diamondPriceFormatted,
            totalText,
        };
    },
});
</script>

<style>
.dsum {
    font-size: 14px;
}

.dsum ul {
    max-width: 40em;
    padding: 0;
    overflow-x: hidden;
    list-style: none;
}

.dsum ul span:first-child {
    padding-right: 0.33em;
    background: white;
}

.dsum ul span + span {
    float: right;
    padding-left: 0.33em;
    background: white;
}
</style>
